import { FormProvider } from "react-hook-form";
import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import "../form.css";
import { DropdownComponent } from "../dropdown";
import "../../../common styling";
import {  GetMinStep, 
          DAY, 
          DROPDOWN_LIST_NONE_ID,
          sessionOptions,
          DROPDOWN_LIST_NONE,
          durationTypeOptions,
          DURATION_SESSION,
          NO} from '../../../common/common'
import { TABLE_ROW_BACKGROUND_COLOR } from "../../../common styling";
import { OrderPairLogic } from "./order_pair_form_logic";
import { selectAccounts, selectInstruments } from "../../../redux/dropDownSlice";
import { useSelector } from "react-redux";

export const OrderPairForm = ({instrument_code, onClose}) => {
  const {
    buyTradingAccount, setBuyTradingAccount, sellTradingAccount, setSellTradingAccount, 
    durationType, code,
    setDurationType, setCode,
    buyPrice, setBuyPrice, sellPrice, setSellPrice, price_dec, buyQty, setBuyQty, sellQty, setSellQty,
    qty_dec, 
    session, setSession,
    qty_step, setQtyStep, price_step, setPriceStep,
    handleSubmit, onSubmit, setReplace,

  } = OrderPairLogic(onClose);

  useEffect(() => {
    if (instrument_code && instrument_code !== code) {
      setCode(instrument_code);
    }
  }, [instrument_code, setCode, code]);

  const [isSessionDisabled, setIsSessionDisabled] = useState(true);
  // implement session orders later
  // const onSessionDropDownChange = useCallback((e) => {setSession(e.target.value)}, [setSession]);
  const dropDownInstrumentsData = useSelector(selectInstruments);
  const dropDownTradingAccountsData = useSelector(selectAccounts);

  const instrumentDropDownList = { 
    options: dropDownInstrumentsData,  
    selectedValue: instrument_code,  
    default: 'Select Instrument', 
    labelName: 'Instrument' 
  };
  
  const buyTradingAccountsDropDownList = { 
    options: dropDownTradingAccountsData,  
    selectedValue: DROPDOWN_LIST_NONE_ID,  
    default: 'Select Buy Account', 
    labelName: 'Buy Account' 
  };
  
  const sellTradingAccountsDropDownList = { 
    options: dropDownTradingAccountsData,  
    selectedValue: DROPDOWN_LIST_NONE_ID,  
    default: 'Select Sell Account', 
    labelName: 'Sell Account' 
  };
  
  const sessionDropDownList = { 
    options: sessionOptions,  
    selectedValue: DROPDOWN_LIST_NONE_ID,  
    default: 'Select Session', 
    labelName: 'Session' 
  };

  const durationTypeDropDownList = { 
    options: durationTypeOptions,  
    selectedValue: DAY,  
    default: 'Select Duration', 
    labelName: 'Duration' 
  };

  useEffect(() => { setQtyStep(GetMinStep(qty_dec)); }, [qty_dec, setQtyStep]);
  useEffect(() => { setPriceStep(GetMinStep(price_dec)); }, [price_dec, setPriceStep]);

  const onInputBuyQty = (e) => { setBuyQty(e.target.value); };
  const onInputSellQty = (e) => { setSellQty(e.target.value); };

  const handleCancel = () => {
    onClose();
  };

  // 2. Handle Duration Type dropdown changes
  useEffect(() => {
    if (durationType === DURATION_SESSION) {
      setIsSessionDisabled(false);
    } else {
      setIsSessionDisabled(true);
      setSession(DROPDOWN_LIST_NONE);
    }
  }, [durationType, setSession]);

  useEffect(() => {
    setReplace(NO);
  }, [setReplace]);

  return (
    <>
    <div>
      <FormProvider>
      <div className="order-form-container">
        <form className="window-amend-center" onSubmit={handleSubmit(onSubmit)}>
          <h2 className="order-amend-title">Order Pair</h2>
          <div className="form-control" style={{borderColor: TABLE_ROW_BACKGROUND_COLOR, backgroundColor: TABLE_ROW_BACKGROUND_COLOR}}>
          
           <DropdownComponent 
              labelName={instrumentDropDownList.labelName} 
              value={ code }
              default={instrumentDropDownList.default} 
              options={instrumentDropDownList.options} 
              onSearchChange={(e) => setCode(e.target.value)} 
            />

            {/* Separator line */}
            <hr style={{ 
              gridColumn: '1 / -1',  // Span across both columns
              margin: '15px 0',
              borderTop: '1px solid #ccc',
              width: '100%'
            }} />

            <DropdownComponent 
              labelName={buyTradingAccountsDropDownList.labelName} 
              value={ buyTradingAccount }
              default={buyTradingAccountsDropDownList.default} 
              options={buyTradingAccountsDropDownList.options} 
              onSearchChange={(e) => setBuyTradingAccount(e.target.value)} 
            />

            <label className="order-label">Buy Price</label>
            <input className="form_input" type="number" step={ price_step } min={ price_step } placeholder='Buy Price' value={buyPrice} onChange={(e)=>setBuyPrice(e.target.value)} name="Price" />
            <label className="order-label">Buy Quantity</label>
            <input className="form_input" type="number" name="Quantity" step={ qty_step } min={ qty_step } placeholder='Buy Quantity' value={ buyQty } onInput={onInputBuyQty} />

            {/* Separator line */}
            <hr style={{ 
              gridColumn: '1 / -1',  // Span across both columns
              margin: '15px 0',
              borderTop: '1px solid #ccc',
              width: '100%'
            }} />

            <DropdownComponent 
              labelName={sellTradingAccountsDropDownList.labelName} 
              value={ sellTradingAccount }
              default={sellTradingAccountsDropDownList.default} 
              options={sellTradingAccountsDropDownList.options} 
              onSearchChange={(e) => setSellTradingAccount(e.target.value)} 
            />

            <label className="order-label">Sell Price</label>
            <input className="form_input" type="number" step={ price_step } min={ price_step } placeholder='Sell Price' value={sellPrice} onChange={(e)=>setSellPrice(e.target.value)} name="Price" />
            <label className="order-label">Sell Quantity</label>
            <input className="form_input" type="number" name="Quantity" step={ qty_step } min={ qty_step }  placeholder='Sell Quantity' value={ sellQty } onInput={onInputSellQty} />

            {/* Separator line */}
            <hr style={{ 
              gridColumn: '1 / -1',  // Span across both columns
              margin: '15px 0',
              borderTop: '1px solid #ccc',
              width: '100%'
            }} />

            <DropdownComponent 
              labelName={durationTypeDropDownList.labelName} 
              value={durationType}
              default={durationTypeDropDownList.default} 
              options={durationTypeDropDownList.options} 
              onSearchChange={(e) => setDurationType(e.target.value)} 
            />

            <DropdownComponent 
              labelName={sessionDropDownList.labelName} 
              value={session}
              default={sessionDropDownList.default} 
              options={sessionDropDownList.options} 
              onSearchChange={(e) => setSession(e.target.value)} 
              disabled={isSessionDisabled}
            />


            <Button className="orderbutton" variant="secondary" size="lg" type="button" onClick={handleCancel}>Cancel</Button>
            <Button className="orderbutton" variant="success" size="lg" type="submit"  style={{float: 'right'}} >Submit</Button>
          </div>
        </form>
      </div>
      </FormProvider>
    </div>
    </>
  );
}
